import { AdyenTransactionsOverview } from "../pages/reporting/AdyenTransactionsOverview";
import { AdyenPaiementsOverview } from "../pages/reporting/AdyenPaiementsOverview";
import { HomePage } from "../pages/HomePage";
import { AdyenReportsOverview } from "../pages/reporting/AdyenReportsOverview";
 


export const routes = [
  {
    element: <HomePage/>,
    path: "/",
  },
  {
    element: <AdyenPaiementsOverview />,
    path: "/paiements",
  },
  {
    element: <AdyenTransactionsOverview />,
    path: "/transactions",
  },
  {
    element: <AdyenReportsOverview />,
    path: "/reports",
  },
];
